import React from 'react'
import PropTypes from 'prop-types'
import {Select, Button} from 'antd'
import {LeftOutlined, RightOutlined} from '@ant-design/icons'

class Toolbar extends React.Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.node.isRequired,
    localizer: PropTypes.object.isRequired,
    onNavigate: PropTypes.func.isRequired,
    onView: PropTypes.func.isRequired,
  }

  navigate = (direction) => {
    this.props.onNavigate(direction)
  }

  view = (view) => {
    this.props.onView(view)
  }

  render() {
    let {view, views, label, localizer: {messages}} = this.props

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <Button.Group size="large">
            <Button
              icon={<LeftOutlined />}
              onClick={this.navigate.bind(null, 'PREV')}
            />
            <Button
              onClick={this.navigate.bind(null, 'TODAY')}
            >
              {messages.today}
            </Button>
            <Button
              icon={<RightOutlined />}
              onClick={this.navigate.bind(null, 'NEXT')}
            />
          </Button.Group>
        </span>

        <span className="rbc-toolbar-label">
          {label}
        </span>

        <span className="rbc-btn-group">
          <Select
            size="large"
            value={view}
            style={{width: 120}}
            onChange={this.view}
          >
            {views.map(view =>
              <Select.Option
                key={view}
                value={view}
              >
                {messages[view]}
              </Select.Option>
            )}
          </Select>
        </span>
      </div>
    )
  }
}

export default Toolbar
